import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { UserContext } from "../../contexts/user.context";
import Navbar from "../navbar/navbar.comp";
import "./channel.style.scss";
import ProfileHeader from "../profileHeader/profileHeader.comp";
import { useParams } from 'react-router-dom';
import {
    getChallengesForUser,
    deleteMyChallenge, updateMyChallenge,
    postChannelDoc, getMyChallengesForChannel,
    getChannelDoc
} from "../../utils/firebase/firebase.utils";
import MyChallenge from "../myChallenge/myChallenge.comp";
import SmallButton from "../smallButton/smallButton.comp";
import Button from "../button/button.comp";
import Tags from "../tags.comp";
import { useChannel } from '../../contexts/channel.context.jsx';
import { useChallenge } from '../../contexts/challenges.context';
import AddChallenge from "../addChallenge/addChallenge.comp.jsx";
import { initialChallenges } from "../../utils/initialObjects.comp.jsx";
import { formatFirestoreTimestamp } from "../../utils/dating.utils.js";
import ChallengeCard from "../challengeCard/challengeCard.comp.jsx";

const Channel = () => {

    //Nav & Contexts
    const navigate = useNavigate();

    const { selectedChannel } = useChannel();
    const { setSelectedChallenge } = useChallenge();
    const { userID } = useContext(UserContext);

    const { linkID } = useParams();

    //Loading Influencer
    const intitialInfluencer = {
        displayName: 'Loading...',
        imageURL: "https://www.digitary.net/wp-content/uploads/2021/07/Generic-Profile-Image.png"
    }
    const [channel, setChannel] = useState(intitialInfluencer);
    const [anchor, setAnchor] = useState();
    const [loadedBoolean, setLoadedBoolean] = useState(false)

    useEffect(() => {
        if (linkID) {
            const timer = setTimeout(async () => {
                const channel = await getChannelDoc(linkID);

                setChannel(channel);
                setAnchor(channel);
                setLoadedBoolean(true)
            }, 200);

            return () => clearTimeout(timer);
        } else {
            navigate('/'); // Redirect to home if no challenge is selected
        }

    }, []);


    //Loading Challenges
    const [challenges, setChallenges] = useState(initialChallenges);
    useEffect(() => {
        const timer = setTimeout(async () => {
            const loadedChallenges = await getMyChallengesForChannel(linkID);

            // Sort by createAt if it exists, otherwise treat as the latest date
            loadedChallenges.sort((a, b) => {
                const dateA = a.createdAt ? new Date(a.createdAt.seconds * 1000) : new Date(); // Treat missing createdAt as the current date
                const dateB = b.createdAt ? new Date(b.createdAt.seconds * 1000) : new Date(); // Treat missing createdAt as the current date
                return dateB - dateA; // Sort descending (newer dates first)
            });

            setChallenges(loadedChallenges);
            setFilteredChallenges(loadedChallenges);

        }, 200);

        return () => clearTimeout(timer);
    }, []);

    const handleRefresh = async () => {
        const timer = setTimeout(async () => {

            const loadedChallenges = await getChallengesForUser(linkID);
            loadedChallenges.sort((a, b) => {
                const dateA = a.createdAt ? new Date(a.createdAt.seconds * 1000) : new Date(); // Treat missing createdAt as the current date
                const dateB = b.createdAt ? new Date(b.createdAt.seconds * 1000) : new Date(); // Treat missing createdAt as the current date
                return dateB - dateA; // Sort descending (newer dates first)
            });
            setChallenges(loadedChallenges);
            setFilteredChallenges(loadedChallenges);
            setAddChallengePopUp(false)
        }, 1000);

        return () => clearTimeout(timer);
    }


    //Split between Private and Public Challenges
    const [privateCount, setPrivateCount] = useState(0)
    useEffect(() => {
        // Count the number of challenges with isLive set to false
        const count = challenges.reduce((acc, challenge) => {
            return !challenge.isLive ? acc + 1 : acc;
        }, 0);

        // Set the private count
        setPrivateCount(count);
    }, [challenges])


    const [displayInfo, setDisplayInfo] = useState(false);
    const toggleDisplay = () => {
        setDisplayInfo(!displayInfo)
    }


    const handleNavigateToChallenge = (challenge) => {
        setSelectedChallenge(challenge)
        navigate(`/challenge/${challenge.id}`);
    };


    // Edit Challenges
    const [editPopUp, setEditPopUp] = useState(false)
    const handleEdit = () => {
        setEditPopUp(true)
    }
    const handleCloseEdit = () => {
        setEditPopUp(false)
    }


    //Deleting Challenge
    const [deleteChallenge, setDeleteChallenge] = useState(false)
    const [challengeToDeleteId, setChallengeToDeleteId] = useState(false)
    const handleDelete = (id) => {
        console.log(id)
        setEditPopUp(false)
        setDeleteChallenge(true)
        setChallengeToDeleteId(id)
    }
    const challengeToDeleteObject = challenges.find(challenge => challenge.id === challengeToDeleteId);
    const handleCancelDeleteThisChallenge = () => {
        setEditPopUp(true)
        setDeleteChallenge(false)
        setChallengeToDeleteId(false)
    }
    const [deleting, setDeleting] = useState(false)
    const [deleted, setDeleted] = useState(false)
    const handleDeleteThisChallenge = () => {
        try {
            setDeleting(true)
            deleteMyChallenge(challengeToDeleteId)

            setDeleting(false)
            setDeleted(true)
        }
        catch (error) {
            console.error('Error deleteing challenge:', error);
        }
    }
    const handleCloseDelete = () => {
        setDeleteChallenge(false)
        setChallengeToDeleteId(false)
        setDeleted(false)
        handleRefresh()
    }


    //Making Channel Live
    const [liveChallenge, setLiveChallenge] = useState(false)
    const [challengeToMakeLiveId, setChallengeToMakeLiveId] = useState(false)
    const handlePostToChannel = (id) => {
        console.log(id)
        setEditPopUp(false)
        setLiveChallenge(true)
        setChallengeToMakeLiveId(id)
    }
    const challengeToMakeLiveObject = challenges.find(challenge => challenge.id === challengeToMakeLiveId);
    const handleCancelMakeThisChallengeLive = () => {
        setEditPopUp(true)
        setLiveChallenge(false)
        setChallengeToMakeLiveId(false)
    }
    const [postingLive, setPostingLive] = useState(false)
    const [postedLive, setPostedLive] = useState(false)
    const handleMakeThisChannelLive = async () => {

        const updatedData = { isLive: false };

        try {
            setPostingLive(true)
            await updateMyChallenge(challengeToMakeLiveId, updatedData);

            setPostingLive(false)
            setPostedLive(true)
            console.log('Challenge status updated successfully.');
        }
        catch (error) {
            console.error('Error toggling challenge status:', error);
        }
    }
    const handleCloseMakeChannelLive = () => {
        setLiveChallenge(false)
        setChallengeToMakeLiveId(false)
        setPostedLive(false)
        handleRefresh()
    }


    //Toggle Switch
    const handleToggleLive = () => {
        console.log()
    };

    // const myPageBoolean = userID === uniqueId;
    const myPageBoolean = false;

    const handleCreate = () => {
        navigate('/create')
    }

    const handleOpenLink = (url) => {
        window.open(url, '_blank');
    };


    const [searchValue, setSearchValue] = useState("");
    const handleClearSearch = () => {
        setSearchValue('')
    }
    const tags = [
        "Reading",
        "Motivation",
        "Food",
        "Sports",
        "Nature",
        "Meditation",
        "Journalling"
    ];
    const handleTagClick = (tag) => {
        setSearchValue(tag);
        console.log(tag)
    };
    const [filteredChallenges, setFilteredChallenges] = useState(initialChallenges);
    useEffect(() => {
        if (searchValue === "") {
            setFilteredChallenges(challenges);
        } else {
            setFilteredChallenges(challenges.filter(challenge =>
                challenge.title.toLowerCase().includes(searchValue.toLowerCase()) ||
                challenge.about.toLowerCase().includes(searchValue.toLowerCase())
            ));
        }
    }, [searchValue, challenges]);

    const [shareLinkCopied, setShareLinkCopied] = useState(false)
    const handleCopyShareLink = () => {

        const shareLink = `${window.location.origin}/channel/${channel.id}`;

        navigator.clipboard.writeText(shareLink).then(() => {
            console.log("Share link copied to clipboard: ", shareLink);
            setShareLinkCopied(true);
        }).catch(err => {
            console.error("Failed to copy share link: ", err);
        });
    }
    const [sharePopUp, setSharePopUp] = useState(false)
    const handleShare = () => {
        setSharePopUp(!sharePopUp)
        setShareLinkCopied(false)
    }


    // Edit Challenges
    const [editChannel, setEditChannel] = useState(false)
    const handleEditChannel = () => {
        setEditChannel(true)
    }
    const handleCloseEditChannel = () => {
        setEditChannel(false)
        saved ? (
            setSaved(false)
        ) : (
            setChannel(anchor)
        )
    }

    const sanitizeTag = (tag) => {
        return tag.toLowerCase().replace(/\s+/g, '');
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setChannel(prevState => ({ ...prevState, [name]: value }));
    };
    const handleTagInputChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = sanitizeTag(value);

        setChannel(prevState => ({ ...prevState, [name]: sanitizedValue }));
    };
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const handleSaveChanges = async () => {

        try {
            setSaving(true)
            await postChannelDoc(channel.id, channel);

            setSaving(false)
            setSaved(true)
            console.log('Challenge status updated successfully.');
        }
        catch (error) {
            console.error('Error toggling challenge status:', error);
        }

    }

    const handleCancelChanges = () => {
        setChannel(anchor)
        setEditChannel(false)
    }


    function formatCreatedAtToDateString(createdAt) {
        // Convert Firebase Timestamp to JavaScript Date object
        const date = new Date(createdAt.seconds * 1000);

        // Options for formatting the date (MMM-YYYY format)
        const options = { year: 'numeric', month: 'long' };

        // Format the date string and replace space with a dash
        return date.toLocaleDateString('en-US', options);
    }


    // Add Challenge
    const [addChallengePopUp, setAddChallengePopUp] = useState(false)
    const handleAdd = () => {
        setAddChallengePopUp(true)
        console.log(true)
    }
    const handleCloseAddChallenge = () => {
        setAddChallengePopUp(false)
    }

    return (
        <div>
            {/* Navbar */}
            <div className="section">
                <Navbar />
            </div>

            {/* Loading Circle */}
            {
                !loadedBoolean ? (
                    <div className="loading-circle"></div>
                ) : null
            }

            {/* Profile Header*/}
            {
                loadedBoolean ? (
                    <div className="section frame">
                        <ProfileHeader
                            imageURL={channel.imageURL}
                            displayName={channel.title}
                            subtitle={channel.subtitle}
                            about={channel.about}
                            toggleDisplay={toggleDisplay}
                            myPage={myPageBoolean}
                            onCreate={handleCreate}
                        />

                        {/* Edit & Share Button */}
                        <div
                            style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}
                        >
                            <Button text={'Share'} option={'blue-inverted'} onClick={handleShare} />
                            {
                                userID === channel.userID ? (
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                                        <Button text={'Add +'} option={'green'} onClick={handleAdd} />
                                        <Button text={'Edit'} option={'button-linked-text'} onClick={handleEditChannel} />
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                ) : null
            }

            {/* Add Challenge */}
            {
                addChallengePopUp === true ? (
                    <AddChallenge
                        userID={userID}
                        onClose={() => handleCloseAddChallenge()}
                        channelID={channel.id}
                        onChallengeAdded={handleRefresh}
                    />
                ) : null
            }

            {/* Search Bar */}
            {
                loadedBoolean ? (
                    <div className="section frame" style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="text"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            placeholder="Filter challenges..."
                            style={{ padding: "8px", flex: 1, marginRight: "8px" }}
                        />
                        {
                            searchValue ? (
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleClearSearch}
                                >
                                </div>
                            ) : null
                        }
                    </div>
                ) : null
            }

            {/* Challenges */}
            {
                loadedBoolean ? (
                    <div className="frame">
                        {
                            userID === channel.userID ? (
                                <div
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                                >
                                    <Button text={'Edit'} option={'button-linked-text'} onClick={handleEdit} />
                                </div>
                            ) : null
                        }
                        <div className="card-display">
                            {/* <div style={{ minHeight: '800px' }}> */}
                            {
                                filteredChallenges.map((challenge, index) => {

                                    return (
                                        <ChallengeCard
                                            id={challenge.id}
                                            channelID={challenge.channelID}
                                            key={index}
                                            imageURL={challenge.imageURL}
                                            title={challenge.title}
                                            eventTime={challenge.eventTime}
                                            eventsTotal={challenge.eventsTotal}
                                            weeks={challenge.weeks}
                                            about={challenge.about}
                                            info={challenge.info}
                                            onClick={() => handleNavigateToChallenge(challenge)}
                                            video={challenge.videoURL}
                                            videoURL={challenge.videoURL}
                                            challengesLoaded={true}
                                            channelImageURL={channel ? channel.imageURL : ''}
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>
                ) : null
            }

            {/* Pop Up Info */}
            {displayInfo === true && (
                <div className="inf-pop-up-container">
                    <div className="inf-pop-up">
                        <div className="inf-pop-up-header">
                            <div className="title">
                                <h2>About</h2>
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={toggleDisplay}
                                >
                                </div>
                            </div>
                        </div>
                        <div className="inf-pop-up-scroll-view">
                            <div className="info">
                                {
                                    channel.about.split('\n\n').map((paragraph, index) => (
                                        <React.Fragment key={index}>
                                            <p style={{ marginBottom: '12px' }}>{paragraph}</p>
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                            {
                                // Check if at least one of the social media links is present
                                channel.youtube ||
                                    channel.facebook ||
                                    channel.instagram ||
                                    channel.twitter ||
                                    channel.myWebsiteLink ? (
                                    <div>
                                        <div className="title">
                                            <h2>Links</h2>
                                        </div>
                                        {
                                            channel.myWebsiteLink ? (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${channel.myWebsiteImageUrl})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>{channel.myWebsiteName}</p>
                                                        <p onClick={() => handleOpenLink(channel.myWebsiteLink)}>{channel.myWebsiteLink}</p>
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                        {
                                            channel.youtube && (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${'https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/1024px-YouTube_full-color_icon_%282017%29.svg.png?20240107144800'})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>youtube</p>
                                                        <p onClick={() => handleOpenLink(channel.youtube)}>{channel.youtube}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            channel.facebook && (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Facebook_icon_2013.svg/600px-Facebook_icon_2013.svg.png?20161223201621'})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>facebook</p>
                                                        <p onClick={() => handleOpenLink(channel.facebook)}>{channel.facebook}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            channel.instagram && (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png'})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>instagram</p>
                                                        <p onClick={() => handleOpenLink(channel.instagram)}>{channel.instagram}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            channel.twitter && (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${'https://upload.wikimedia.org/wikipedia/commons/5/5a/X_icon_2.svg'})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>x</p>
                                                        <p onClick={() => handleOpenLink(channel.twitter)}>{channel.twitter}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                ) : null
                            }

                            <div className="title">
                                <h2>Details</h2>
                            </div>
                            <div className="detail">
                                <div className="detail-icon-wrapper">
                                    <div
                                        className="detail-icon"
                                        style={{
                                            backgroundImage: `url(${'https://i.pinimg.com/474x/7c/0e/4e/7c0e4e447a43a52a3473690cac3e7a0b.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    >
                                    </div>
                                </div>
                                <div className="detail-info">
                                    <p>{challenges.length} challenges</p>
                                </div>
                            </div>
                            <div className="detail">
                                <div className="detail-icon-wrapper">
                                    <div
                                        className="detail-icon"
                                        style={{
                                            backgroundImage: `url(${'https://static.vecteezy.com/system/resources/previews/005/988/959/original/calendar-icon-free-vector.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    >
                                    </div>
                                </div>
                                <div className="detail-info">
                                    <p>joined {formatCreatedAtToDateString(channel.createdAt)}</p>
                                </div>
                            </div>
                            {
                                channel.location ? (
                                    <div className="detail">
                                        <div className="detail-icon-wrapper">
                                            <div
                                                className="detail-icon"
                                                style={{
                                                    backgroundImage: `url(${'https://previews.123rf.com/images/flatdesign/flatdesign2009/flatdesign200900365/154641614-globe-earth-icon-world-icon.jpg'})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                            </div>
                                        </div>

                                        <div className="detail-info">
                                            <p>{channel.location}</p>
                                        </div>
                                    </div>
                                ) : null
                            }
                            <div className="footer-margin">
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Channel Edit Pop Up */}
            {
                editChannel === true ? (
                    <div className="edit-channel-pop-up-container">
                        <div className="edit-channel-pop-up">
                            <div className="edit-channel-pop-up-header">
                                <div className="title">
                                    <h2>Channel Settings</h2>
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseEditChannel}
                                    >
                                    </div>
                                </div>
                            </div>
                            {
                                saving ? (
                                    <div className="loading-circle"></div>
                                ) : saved ? (
                                    <div>
                                        <p>Update successful</p>
                                        <Button text={'close'} option={'yellow'} onClick={handleCloseEditChannel} />
                                    </div>
                                ) : (
                                    <div className="edit-channel-pop-up-scroll-view">
                                        <div>
                                            <div style={{ marginTop: '8px' }}>
                                                <p style={{ fontWeight: '500', color: 'var(--fontgrey)', fontSize: 'small', textAlign: 'left', marginTop: '8px', marginBottom: '4px' }}>Channel Image</p>
                                                <input
                                                    type="text"
                                                    name="imageURL"
                                                    value={channel.imageURL}
                                                    onChange={handleInputChange}
                                                    placeholder="Profile Image URL"
                                                />
                                            </div>
                                            <div className="channel-display-name-input">
                                                <p style={{ fontWeight: '500', color: 'var(--fontgrey)', fontSize: 'small', textAlign: 'left', marginTop: '8px', marginBottom: '4px' }}>Channel Display Name</p>
                                                <input
                                                    type="text"
                                                    name="title"
                                                    value={channel.title}
                                                    onChange={handleInputChange}
                                                    placeholder="Channel Title"
                                                    maxLength={40}
                                                />
                                            </div>
                                            <div className="channel-thumbnail-input">
                                                <p style={{ fontWeight: '500', color: 'var(--fontgrey)', fontSize: 'small', textAlign: 'left', marginTop: '8px', marginBottom: '4px' }}>Subtitle</p>
                                                <input
                                                    type="text"
                                                    name="subtitle"
                                                    value={channel.subtitle}
                                                    onChange={handleInputChange}
                                                    placeholder="Subtitle"
                                                    maxLength={40}
                                                />
                                            </div>
                                            <div className="channel-description-input">
                                                <p style={{ fontWeight: '500', color: 'var(--fontgrey)', fontSize: 'small', textAlign: 'left', marginTop: '8px', marginBottom: '4px' }}>Description</p>
                                                <textarea
                                                    name="about"
                                                    value={channel.about}
                                                    onChange={handleInputChange}
                                                    placeholder="More detials about your challenge"
                                                    rows={10} // Initial number of rows (optional)
                                                    style={{ padding: '4px', resize: 'none', overflowY: 'auto', width: '100%', boxSizing: 'border-box' }} // Optional styling to prevent manual resizing
                                                />
                                            </div>
                                        </div>

                                        {/* About Settings */}
                                        <div

                                            style={{ textAlign: 'left', marginBottom: '40px' }}
                                        >
                                            <h3 style={{ textAlign: 'left', marginBottom: '8px' }}>About</h3>
                                            <p style={{ fontSize: 'small', marginTop: 0 }}>More details about your channel.</p>

                                            <div className="about-links-input">
                                                <p style={{ fontWeight: '500', color: 'var(--fontgrey)', fontSize: 'small', textAlign: 'left', marginTop: '8px', marginBottom: '4px' }}>Links</p>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    <input
                                                        name="youtube"
                                                        value={channel.youtube}
                                                        onChange={handleInputChange}
                                                        placeholder="youtube"
                                                    />
                                                    <input
                                                        name="facebook"
                                                        value={channel.facebook}
                                                        onChange={handleInputChange}
                                                        placeholder="facebook"
                                                    />
                                                    <input
                                                        name="instagram"
                                                        value={channel.instagram}
                                                        onChange={handleInputChange}
                                                        placeholder="instagram"
                                                    />
                                                    <input
                                                        name="twitter"
                                                        value={channel.twitter}
                                                        onChange={handleInputChange}
                                                        placeholder="twitter"
                                                    />
                                                </div>
                                            </div>
                                            <div className="about-your-website-input">
                                                <p style={{ fontWeight: '500', color: 'var(--fontgrey)', fontSize: 'small', textAlign: 'left', marginTop: '8px', marginBottom: '4px' }}>Your Website</p>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    <input
                                                        name="myWebsiteImageUrl"
                                                        value={channel.myWebsiteImageUrl}
                                                        onChange={handleInputChange}
                                                        placeholder="Image link"
                                                    />
                                                    <input
                                                        name="myWebsiteName"
                                                        value={channel.myWebsiteName}
                                                        onChange={handleInputChange}
                                                        placeholder="Name"
                                                    />
                                                    <input
                                                        name="myWebsiteLink"
                                                        value={channel.myWebsiteLink}
                                                        onChange={handleInputChange}
                                                        placeholder="Website Url"
                                                    />
                                                </div>
                                            </div>
                                            <div className="about-your-website-input">
                                                <p style={{ fontWeight: '500', color: 'var(--fontgrey)', fontSize: 'small', textAlign: 'left', marginTop: '8px', marginBottom: '4px' }}>Location</p>
                                                <div>
                                                    <input
                                                        name="location"
                                                        value={channel.location}
                                                        onChange={handleInputChange}
                                                        placeholder="Location"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: 'auto', marginBottom: '0' }}>
                                            <Button text={'cancel'} option={'yellow'} onClick={handleCancelChanges} />
                                            <Button text={'save'} option={'green'} onClick={handleSaveChanges} />
                                        </div>
                                        <div className="footer-margin">
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                ) : null
            }

            {/* Edit Challenges Pop Up */}
            {
                editPopUp === true ? (
                    <div className="edit-challenges-pop-up-container">
                        <div className="edit-challenges-pop-up">
                            <div className="edit-challenges-pop-up-header">
                                <div className="title">
                                    <div />
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseEdit}
                                    />
                                </div>
                            </div>
                            <div className="edit-challenges-pop-up-scroll-view">
                                {
                                    challenges.map((challenge) => {

                                        return (
                                            <div style={{ marginBottom: '12px' }}>
                                                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                                    <div
                                                        style={{
                                                            backgroundImage: `url(${challenge.imageURL})`,
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat',
                                                            height: '80px',
                                                            width: '80px',
                                                            borderRadius: '12px'
                                                        }}
                                                    >
                                                    </div>
                                                    <div style={{ textAlign: 'left' }}>
                                                        <p style={{ margin: '0' }}>{challenge.title}</p>
                                                        <p style={{ fontSize: 'small', fontWeight: '500', color: 'grey', margin: '0' }}>{formatFirestoreTimestamp(challenge.createdAt)}</p>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'end', gap: '4px', marginLeft: 'auto', marginRight: '0' }} >
                                                        <SmallButton text={'delete'} option={'red'} onClick={() => handleDelete(challenge.id)} />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                <div className="footer-margin">
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Delete Challenge Pop Up */}
            {
                deleteChallenge === true ? (
                    <div className="delete-challenge-pop-up-container">
                        <div className="delete-challenge-pop-up">
                            <div className="delete-challenge-pop-up-header">
                                <div className="title">
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    // onClick={handleCloseEdit}
                                    />
                                </div>
                            </div>
                            {
                                deleting ? (
                                    <div className="delete-challenge-pop-up-scroll-view ">
                                        <p style={{ width: '100%', textAlign: 'center' }}>Deleting challenge...</p>
                                        <div className="my-challenge-details-delete-loading-circle"></div>
                                    </div>
                                ) : (
                                    deleted ? (
                                        <div className="delete-challenge-pop-up-scroll-view ">
                                            <p style={{ width: '100%', textAlign: 'center' }}>Challenge deleted</p>
                                            <Button text={'Close'} option={'yellow'} onClick={handleCloseDelete} />
                                        </div>
                                    ) : (
                                        <div className="delete-challenge-pop-up-scroll-view">
                                            <div className='channel-description'>
                                                <p style={{ width: '100%', textAlign: 'center' }}>Are you sure you want to <strong>delete this challenge</strong>?</p>
                                            </div>
                                            {
                                                // Render the found challenge, if it exists
                                                challengeToDeleteObject && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center' }}>
                                                        <div
                                                            style={{
                                                                backgroundImage: `url(${challengeToDeleteObject.imageURL})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat',
                                                                height: '80px',
                                                                width: '80px',
                                                                borderRadius: '12px'
                                                            }}
                                                        >
                                                        </div>
                                                        <div style={{ textAlign: 'left' }}>
                                                            <p style={{ margin: '0' }}>{challengeToDeleteObject.title}</p>
                                                            <p style={{ fontSize: 'small', fontWeight: '500', color: 'grey', margin: '0' }}>{formatFirestoreTimestamp(challengeToDeleteObject.createdAt)}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            <div style={{ display: 'flex', gap: '12px', marginTop: '12px', marginBottom: '12px', justifyContent: "center" }}>
                                                <SmallButton text={'Cancel'} option={'yellow'} onClick={handleCancelDeleteThisChallenge} />
                                                <SmallButton text={'Delete'} option={'red'} onClick={handleDeleteThisChallenge} />
                                            </div>
                                            <p style={{ fontSize: 'small' }}>This challenge will be deleted from your challenges.</p>
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                ) : null
            }

            {/* Remove Challenge Pop Up */}
            {
                liveChallenge === true ? (
                    <div className="delete-challenge-pop-up-container">
                        <div className="delete-challenge-pop-up">
                            <div className="delete-challenge-pop-up-header">
                            </div>
                            {
                                postingLive ? (
                                    <div className="delete-challenge-pop-up-scroll-view ">
                                        <p style={{ width: '100%', textAlign: 'center' }}>Removing challenge...</p>
                                        <div className="my-challenge-details-delete-loading-circle"></div>
                                    </div>
                                ) : (
                                    postedLive ? (
                                        <div className="delete-challenge-pop-up-scroll-view ">
                                            <p style={{ width: '100%', textAlign: 'center' }}>Challenge removed from your channel.</p>
                                            <Button text={'Close'} option={'yellow'} onClick={handleCloseMakeChannelLive} />
                                        </div>
                                    ) : (
                                        <div className="delete-challenge-pop-up-scroll-view">
                                            <div className='channel-description'>
                                                <p style={{ width: '100%', textAlign: 'center' }}>Are you sure you want to <strong>remove this challenge</strong> from your channel?</p>
                                            </div>
                                            {
                                                // Render the found challenge, if it exists
                                                challengeToMakeLiveObject && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center' }}>
                                                        <div
                                                            style={{
                                                                backgroundImage: `url(${challengeToMakeLiveObject.imageURL})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat',
                                                                height: '80px',
                                                                width: '80px',
                                                                borderRadius: '12px'
                                                            }}
                                                        >
                                                        </div>
                                                        <div style={{ textAlign: 'left' }}>
                                                            <p style={{ margin: '0' }}>{challengeToMakeLiveObject.title}</p>
                                                            <p style={{ fontSize: 'small', fontWeight: '500', color: 'grey', margin: '0' }}>March 15, 2024</p>
                                                            <p style={{ fontSize: 'small', fontWeight: '500', color: 'grey', margin: '0' }}>{challengeToMakeLiveObject.likes.length} likes</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            <div style={{ display: 'flex', gap: '12px', marginTop: '12px', marginBottom: '12px', justifyContent: "center" }}>
                                                <SmallButton text={'Cancel'} option={'yellow'} onClick={handleCancelMakeThisChallengeLive} />
                                                <SmallButton text={'Remove'} option={'red'} onClick={handleMakeThisChannelLive} />
                                            </div>
                                            <p style={{ fontSize: 'small' }}>This challenge will be removed from your channel. You can find it in your challenges.</p>
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                ) : null
            }

            {/* Pop Up Share */}
            {
                sharePopUp === true ? (
                    <div className="share-pop-up-container">
                        <div className="share-pop-up">
                            <div className="share-pop-up-header">
                                <div className="title">
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleShare}
                                    >
                                    </div>
                                </div>
                                <div
                                    style={{
                                        backgroundImage: `url(${channel.imageURL})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        height: '200px',
                                        width: '200px',
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        borderRadius: '20px'
                                    }}
                                >
                                </div>
                                <h3>{channel.title}</h3>
                                {
                                    shareLinkCopied ? (
                                        <div>
                                            <Button text={'Copied to clipboard!'} option={'blue-inverted-no-hover'} />
                                            <p style={{ fontSize: 'small', textAlign: 'center', margin: '0' }}>You can share this link with others!</p>
                                        </div>
                                    ) : (
                                        <Button text={'Copy share link'} option={'green'} onClick={handleCopyShareLink} />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                ) : null
            }

            <div className="footer-margin">
            </div>
        </div >
    );
};

export default Channel;